import axiosInstance from "./axios-instance";

// Helper function to build query parameters, filtering out empty values
const buildParams = (baseParams, optionalParams = {}) => {
   const params = { ...baseParams };

   Object.entries(optionalParams).forEach(([key, value]) => {
      if (value && value.trim() !== '') {
         params[key] = value;
      }
   });

   return params;
};

/**
 * @desc GET request to return a list of ASA client data with demographic filters
 * @returns ASA client data from azure Database
 */
const getASAGeoData = async (ethnicity, school, selectedGender, selectedAgeRange, selectedIwi) => {
   const params = buildParams(
      { ethnicity, school },
      { selectedGender, selectedAgeRange, selectedIwi }
   );

   return await axiosInstance.get('/map/asa-clients', { params });
};

/**
 * @desc GET request to return a list of user data provided in Purapura DB
 * @returns current user's data from azure Database
 */
const getPPWGeoData = async (serviceType, database, activeClientsOnly, entryDateFrom, entryDateTo, exitDateFrom, exitDateTo, selectedGender, selectedAgeRange, selectedIwi, selectedEthnicity, selectedWellbeing) => {
   const params = buildParams(
      { serviceType, database, activeClientsOnly },
      {
         entryDateFrom,
         entryDateTo,
         exitDateFrom,
         exitDateTo,
         selectedGender,
         selectedAgeRange,
         selectedIwi,
         selectedEthnicity,
         selectedWellbeing
      }
   );

   return await axiosInstance.get('/map/ppw-clients', { params });
};

/**
 * @desc GET request to return Pae Ora client geographical data
 * @returns Pae Ora client data from azure Database
 */
const getPaeOraGeoData = async () => {
   return await axiosInstance.get('/map/pae-ora-clients');
};

/**
 * @desc GET request to return client count with various filters
 * @returns Client count data from azure Database
 */
const getClientCount = async (source, active, serviceType, database, entryDateFrom, entryDateTo, exitDateFrom, exitDateTo, selectedGender, selectedAgeRange, selectedIwi, asaEthnicity, asaSchool, selectedWellbeing) => {
   const params = buildParams(
      { source, active, serviceType, database },
      {
         entryDateFrom,
         entryDateTo,
         exitDateFrom,
         exitDateTo,
         selectedGender,
         selectedAgeRange,
         selectedIwi,
         ethnicity: asaEthnicity,
         school: asaSchool,
         selectedWellbeing
      }
   );

   return await axiosInstance.get('/map/client-count', { params });
};

/**
 * @desc POST request to populate statistical areas
 * @returns Response from statistical areas population operation
 */
const populateStatisticalAreas = async () => {
   return await axiosInstance.post('/map/statistical-areas');
};

/**
 * @desc GET request to retrieve statistical area filters
 * @returns SA2 filter data from azure Database
 */
const getStatisticalFilters = async () => {
   return await axiosInstance.get('/map/sa2-filters');
};

export default {
   getASAGeoData,
   getPPWGeoData,
   getPaeOraGeoData,
   getClientCount,
   getStatisticalFilters,
   populateStatisticalAreas,
};